import { __decorate, __metadata } from "tslib";
import { Serialize } from '@ftr/serialization';
import { ZonedDateTime } from '@js-joda/core';
export class UserAcceptedConditions {
}
__decorate([
    Serialize(() => ZonedDateTime),
    __metadata("design:type", ZonedDateTime)
], UserAcceptedConditions.prototype, "acceptedTimestamp", void 0);
